const megaNav = document.getElementById('customMegaNav');

if (megaNav) {
  const triggers = megaNav.querySelectorAll('.custom-mega-trigger');
  const panels = megaNav.querySelectorAll('.custom-mega-panel');

  function closeAll() {
    panels.forEach(p => p.classList.remove('is-active'));
    triggers.forEach(t => {
      t.classList.remove('is-active');
      t.setAttribute('aria-expanded', 'false');
    });
  }

  triggers.forEach(trigger => {
    const handle = trigger.dataset.menu;
    const panel = megaNav.querySelector(`[data-panel="${handle}"]`);

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isActive = trigger.classList.contains('is-active');
      closeAll();
      if (!isActive) {
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-active');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!megaNav.contains(e.target)) {
      closeAll();
    }
  });
}